.compare-features-section {
  background: var(--light--background-color--1);
  border: solid 1px var(--default--border-color--12);
  border-radius: 8px;
  margin-bottom: var(--space-24);
  padding: var(--space-16);
}

.compare-features-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
}

.features-grid-container {
  display: grid;
  margin-top: var(--space-16);
}

.plan-names-row {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: var(--light--background-color--1);
}

.plan-name-cell {
  text-align: center;
  padding: var(--space-8) var(--space-16);

  &.is-current-plan-column {
    background-color: var(--gray-F9FAFB);
  }
}
